var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.93359 8.5H16.9336V10.5H18.9336V4.5C18.9336 3.4 18.0336 2.5 16.9336 2.5H15.9336V0.5H13.9336V2.5H5.93359V0.5H3.93359V2.5H2.93359C1.82359 2.5 0.943594 3.4 0.943594 4.5L0.933594 18.5C0.933594 19.6 1.82359 20.5 2.93359 20.5H9.93359V18.5H2.93359V8.5ZM2.93359 4.5H16.9336V6.5H2.93359V4.5ZM20.7736 14.78L20.0636 15.49L17.9436 13.37L18.6536 12.66C19.0436 12.27 19.6736 12.27 20.0636 12.66L20.7736 13.37C21.1636 13.76 21.1636 14.39 20.7736 14.78ZM17.2336 14.08L19.3536 16.2L14.0536 21.5H11.9336V19.38L17.2336 14.08Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.9bc442e312a02e3ad7652678d1e76604.svg";
export { ForwardRef as ReactComponent };